/* eslint-disable import/prefer-default-export */

export const INVITE_CLAIM_CHANGED = 'INVITE_CLAIM_CHANGED';
export const IS_SUBMITTING_CHANGED = 'IS_SUBMITTING_CHANGED';
export const ERROR_MESSAGES_CHANGED = 'ERROR_MESSAGES_CHANGED';
